import { getToken } from './secureStorage';

const originalFetch = window.fetch.bind(window);

// مسیرهایی که نباید توکن بگیرند
const SKIP_AUTH_PATHS = [
  '/api/auth/',
  '/api/roomeet/',
  '/api/ai/chat',
  '/api/send-sms',
  '/api/__health',
  '/upload/api/',
];

window.fetch = function (url, options = {}) {
  let urlStr = typeof url === 'string' ? url : (url?.url || '');
  
  // ✅ مسیرهای نسبی که باید به دامنه کامل تبدیل شوند (شامل pdfium.wasm برای APK)
  const RELATIVE_PREFIXES = ['/api', '/payment', '/upload', '/pdfium.wasm', '/media'];
  if (RELATIVE_PREFIXES.some(prefix => urlStr.startsWith(prefix))) {
    urlStr = `https://yadoo20.ir${urlStr}`;
    url = urlStr;
  }
  
  // آیا این مسیر نیاز به توکن دارد؟
  const isApiCall = urlStr.includes('/api/');

  const shouldSkip = SKIP_AUTH_PATHS.some(p => urlStr.includes(p));
  
  if (isApiCall && !shouldSkip) {
    const token = getToken();
    if (token) {
      const existingHeaders = { ...(options.headers || {}) };
      // فقط اگر هدر Authorization از قبل ست نشده باشه اضافه می‌کنیم
      if (!existingHeaders['Authorization'] && !existingHeaders['authorization']) {
        existingHeaders['Authorization'] = `Bearer ${token}`;
      }
      options = { ...options, headers: existingHeaders };
    }
  }
  
  return originalFetch(url, options);
};

console.log('🔐 globalFetchAuth: installed');